import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { metrics, TheWestSection } from '@news-mono/component-library'
import {
    AdTargeting,
    getSocialImageMeta,
    StaticRoutes,
} from '@news-mono/web-common'
import { layout } from '../../../App.routing'

const tokyoPodcastImage = require('./assets/lets_go_tokyo_the_west_live.png')

export const tokyoOlympicsPodcast: StaticRoutes<TheWestSection> = {
    '/sport/olympics/podcast': ({ getAdTargeting, store, config }) => {
        if (
            !isFeatureEnabled(
                toFeatureState(store.getState().toggles),
                'the-west-tokyo-podcast',
            )
        ) {
            return null
        }

        const canonicalUrl = config.publicUrl + '/sport/olympics/podcast'

        const {
            adUnitPath,
            ssAdUnits,
            topics: AdTopics,
        } = getAdTargeting('article', 'default', {
            id: 'sport/olympics',
            title: 'Olympics',
            parent: { id: 'sport', title: 'Sport', metadata: {}, seoTitle: '' },
            metadata: {},
            seoTitle: '',
        })

        const adTargeting: AdTargeting = {
            pageId: 'olympicspodcast',
            adUnitPath,
            ssAdUnits,
            topics: AdTopics,
        }

        return {
            kind: 'page',
            heading: "Let's go Tokyo",
            pageType: 'static',
            hideHeading: true,
            refreshOnInactive: false,
            pageMeta: {
                title: "Let's go Tokyo | The West Live",
                description:
                    "From The West Australian, Let's Go Tokyo, hosted by Mark Readings and Ben O'Shea is a podcast dedicated to bringing you the latest on the 2021 Tokyo Olympic Games.",
                link: [{ rel: 'canonical', href: canonicalUrl }],
                meta: getSocialImageMeta(tokyoPodcastImage, '630', '1200'),
            },
            socialMeta: {
                title: "Let's go Tokyo | The West Live",
                description:
                    "From The West Australian, Let's Go Tokyo, hosted by Mark Readings and Ben O'Shea is a podcast dedicated to bringing you the latest on the 2021 Tokyo Olympic Games.",
            },
            adTargeting,
            section: 'default',
            compositions: [
                layout.composition({
                    type: 'zeus',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        horizontalGutters: true,
                        hasBackgroundFill: true,
                        stretchSelf: true,
                    },
                    contentAreas: {
                        main: [
                            layout.nestedComposition({
                                type: 'box',
                                props: {
                                    verticalSpacing: 'md',
                                },
                                contentAreas: {
                                    main: [
                                        layout.component({
                                            type: 'tokyo-podcast-player-page',
                                            props: {
                                                adUnit: {
                                                    hiddenUntilLoaded: false,
                                                    noticePosition:
                                                        'below-center',
                                                    padding: [
                                                        metrics.thewest.margins
                                                            .md,
                                                        0,
                                                        0,
                                                        0,
                                                    ],
                                                    slot: {
                                                        id: 'leaderboard-one',
                                                        size: 'leaderboardResponsive',
                                                    },
                                                },
                                                twlLogoAdUnit: {
                                                    hiddenUntilLoaded: false,
                                                    noticePosition: 'none',
                                                    padding: [
                                                        metrics.thewest.margins
                                                            .md,
                                                        0,
                                                        0,
                                                        0,
                                                    ],
                                                    slot: {
                                                        id: 'twl-landing',
                                                        size: 'theWestLiveLogo',
                                                    },
                                                },
                                            },
                                        }),
                                    ],
                                },
                            }),
                            layout.component({
                                type: 'iframe',
                                props: {
                                    link: 'https://omny.fm/shows/let-s-go-tokyo/playlists/podcast/embed?style=cover&image=1&share=1&download=1&description=1&subscribe=1&playlistimages=1&playlistshare=1&foreground=0a5158&background=f5f5f5&highlight=fded00',
                                    height: 500,
                                    marginBottom: 'lg',
                                },
                            }),
                            layout.component({
                                type: 'link-banner',
                                props: {
                                    url: `/newslettersubscribe`,
                                    message:
                                        'Get the latest news from thewest.com.au in your inbox.',
                                    cta: 'Sign up for our emails',
                                    verticalGutters: ['md', 'lg'],
                                },
                            }),
                            layout.component({
                                type: 'related-content',
                                props: {
                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: 'olympics',
                                        offset: 0,
                                        pageSize: 3,
                                    },
                                },
                            }),
                        ],
                        sidebar: [
                            layout.component({
                                type: 'ad-unit',
                                props: {
                                    noticePosition: 'below-center',
                                    padding: [
                                        0,
                                        0,
                                        metrics.thewest.margins.md,
                                        0,
                                    ],
                                    slot: {
                                        id: 'sidebar-top',
                                        size: 'desktopMrecHalfPage',
                                        pageType: 'static',
                                    },
                                },
                            }),
                            layout.nestedComposition({
                                type: 'box',
                                props: {
                                    stickyOffset: 350,
                                    fillContainer: true,
                                },
                                contentAreas: {
                                    main: [
                                        layout.component({
                                            type: 'ad-unit',
                                            props: {
                                                noticePosition: 'below-center',
                                                padding: [
                                                    0,
                                                    0,
                                                    metrics.thewest.margins.md,
                                                    0,
                                                ],
                                                slot: {
                                                    id: 'sidebar-middle',
                                                    size: 'desktopMrec',
                                                    pageType: 'static',
                                                },
                                            },
                                        }),

                                        layout.component({
                                            type: 'juliet',
                                            props: {
                                                cardType: {
                                                    type: 'landscape',
                                                    format: 'landscape-smallImage',
                                                },
                                                removeHorizontalGutters: true,
                                                kickerMode: 'hidden',
                                                contentIsTangential: true,
                                                sectionHeader: {
                                                    heading: 'Top Stories',
                                                    section: 'generic',
                                                },
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: 'home',
                                                    offset: 0,
                                                    pageSize: 3,
                                                },
                                            },
                                        }),
                                    ],
                                },
                            }),
                        ],
                    },
                }),
            ],
        }
    },
}
